<template>
  <hr
    class="t-separator border-t border-b-0 border-l-0 border-r-0 border-solid"
    :class="[colorClasses, classes]"
  />
</template>

<script setup lang="ts">
defineProps({
  colorClasses: {
    type: String,
    default: 'border-gray-300',
  },
  classes: {
    type: String,
  },
})
</script>
